import React from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { LucideCircleAlert } from "lucide-react";
import ApprovalCard from "./ApprovalCard";

const approvalsData = [
  {
    category: "Leave",
    name: "Jennifer Lee",
    location: "Philippines",
    leaveType: "Vacation",
    fromDate: "Nov 1, 2025",
    toDate: "Nov 10, 2025",
    days: 10,
    reason: "Family vacation trip",
    dateRequested: "Oct 10, 2025",
  },
  {
    category: "Overtime",
    name: "Robert Taylor",
    location: "India",
    fromDate: "Oct 15, 2025",
    otHours: 8,
    reason: "Family vacation trip",
    dateRequested: "Oct 13, 2025",
  },
  {
    category: "Leave",
    name: "David Martinez",
    location: "Colombia",
    leaveType: "Personal",
    fromDate: "Oct 24, 2025",
    toDate: "Oct 26, 2025",
    days: 2,
    reason: "Medical appointment",
    dateRequested: "Oct 12, 2025",
  },
  {
    category: "Overtime",
    name: "Amanda White",
    location: "Sri Lanka",
    fromDate: "Oct 14, 2025",
    otHours: 5,
    reason: "Client presentation preparation",
    dateRequested: "Oct 13, 2025",
  },
];

const PendingApprovalsTable = () => {
  return (
    <HeaderComponent
      title="Pending Approvals"
      description="Leave and overtime requests awaiting approval"
      bgcolor="bg-orange-50"
      icon={<LucideCircleAlert size={20} />}
      colorTheme="flat-orange"
      border="border-b"
    >
      <div className="overflow-y-auto p-1 h-[500px] space-y-2">
        {approvalsData.map((approval, index) => (
          <ApprovalCard key={index} {...approval} />
        ))}
      </div>
    </HeaderComponent>
  );
};

export default connect()(PendingApprovalsTable);
